import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { usePageMeta } from "@/hooks/usePageMeta";
import { BRAND } from "@/lib/site";
import { PhotoGrid, type ReaderPhoto } from "@/components/site/ReaderPhotos";

export default function GalleryPage() {
  usePageMeta(`Reader gallery | ${BRAND}`, "Handmade gifts our readers made from the projects on this site.");
  const [photos, setPhotos] = useState<ReaderPhoto[] | null>(null);
  useEffect(() => { api.get("/public/gallery").then((r) => setPhotos(r.data)).catch(() => setPhotos([])); }, []);
  return (
    <div className="mx-auto max-w-6xl px-5 pt-14 sm:px-8" data-testid="gallery-page">
      <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-[#23324A]/55">Reader gallery</p>
      <h1 className="font-heading text-4xl font-semibold text-[#23324A] sm:text-5xl lg:text-6xl">Made by you</h1>
      <p className="mt-4 max-w-xl text-[#23324A]/75">Gifts readers made from the projects here. Made one too? Open the project's article and share your photo at the bottom.</p>
      {photos && photos.length === 0 && (
        <div className="calm-card mt-10 p-8 hover:transform-none" data-testid="gallery-empty">
          <p className="font-heading text-xl font-semibold text-[#23324A]">Be the first to share!</p>
          <p className="mt-2 text-sm text-[#23324A]/70">Pick a project, make it, and send a photo from the bottom of the article.</p>
          <Link to="/blog" className="btn-solid mt-5">Find a project</Link>
        </div>
      )}
      <div className="mt-10"><PhotoGrid photos={photos || []} showPost /></div>
    </div>
  );
}
